// NatGen Google Floodlight snippet for completing a quote
export function natgenFloodlightQuoteComplete() {
    // eslint-disable-next-line no-undef
    gtag('event', 'conversion', {
        'allow_custom_scripts': true,
        'u1': '1',
        'send_to': 'DC-1886972/natg694/ngbey000+unique'
    });
}
